export default __webpack_public_path__ + "d46d747de40aa8b814092218306dd9e6.svg";